<template>
  <div>
    <a-popover placement="topLeft" title="Omschrijving">
      <template slot="content">
        <div>
          <div v-for="attachable in attachables" :key="attachable.id">
            <attachment-icon></attachment-icon>
            <AttachableShowLinkComponent :attachable="attachable"></AttachableShowLinkComponent>
          </div>
        </div>
      </template>
      <a-button type="default" v-on:click.stop="onAttachableDrawerOpen">
        <attachment-icon></attachment-icon>
        {{ attachables.length }} bijlage(s)
      </a-button>
    </a-popover>
    <AttachableDrawerTableComponent
        :attachables="attachables"
        :visible="attachableDrawerVisible"
        v-on:close="onAttachableDrawerClose">
    </AttachableDrawerTableComponent>
  </div>
</template>

<script>
export default {
  name: "TaskDescriptionAttachments"
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
